import { render, staticRenderFns } from "./NewSupplierOverview.vue?vue&type=template&id=c8fada64&scoped=true&"
import script from "./NewSupplierOverview.vue?vue&type=script&lang=js&"
export * from "./NewSupplierOverview.vue?vue&type=script&lang=js&"
import style0 from "./NewSupplierOverview.vue?vue&type=style&index=0&id=c8fada64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fada64",
  null
  
)

export default component.exports